import React from 'react';
import { dispactConnect, Action, combineAction } from 'combine-action';
import Line from './Line'
import * as TYPE from './pieces'

class Board extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            line: [1, 2, 3, 4, 5, 6, 7, 8].reverse(),
        };
    }

    movingPion(bijis, from, to) {
        var group = [];
        Array.from(document.querySelectorAll(".line")).forEach((item, index) => {
            var line = [];
            var num = 0;
            Array.from(item.children).forEach((kotak, idx) => {
                var biji = kotak.attributes.getNamedItem('data-biji').nodeValue;
                var id = kotak.attributes.getNamedItem('data-id').nodeValue;
                if (from === id) {
                    biji = '-';
                }
                if (to === id) {
                    biji = bijis;
                }

                if (biji === '-') {
                    num = num + 1;
                    if (idx === (item.children.length - 1)) {
                        line.push(num);
                    }
                } else {
                    if (num) {
                        line.push(num);
                        line.push(biji);
                        num = 0;
                    } else {
                        line.push(biji);
                    }
                }
            });
            group.push(line);
        });
        var susunan = group.map(item => item.join('')).join('/');
        return susunan;
    }

    renderLine() {
        return this.state.line.map((number, index) => {
            var buzz = [];
            var formasiLine = this.props.formasi.split('/').map(item => item);
            formasiLine[index].split('').forEach((b) => {
                if (/[1-9]/.test(b)) {
                    for (var i = 0; i < parseInt(b); i++) {
                        buzz.push('-');
                    }
                } else {
                    buzz.push(b);
                }
            });
            return (
                <Line key={index} number={number} formasi={buzz} />
            );
        });
    }

    lose() {
        return this.props.lose ? (
            <div className="kalah">
                <span>YOU LOSE</span>
            </div>) : null;
    }

    win() {
        return this.props.win ? (
            <div className="kalah">
                <span>YOU WIN</span>
            </div>) : null;
    }

    popupPromosi() {
        const { allPromot, pionSelectPromotion } = this.props;
        return this.props.popupPromosi ? (
            <div className="modalpromosi">
                <div className="boxp">
                    {allPromot[pionSelectPromotion].map((item, index) => {
                        const Piece = TYPE[item];
                        return (
                            <div key={index} className="propi" onClick={() => {
                                var from = pionSelectPromotion.split('').map((x, i) => i ? parseInt(x) - 1 : x).join('');
                                var jalan = from + pionSelectPromotion;
                                var susunan = this.movingPion(item, from, pionSelectPromotion);
                                this.props.updateState({
                                    susunan,
                                    susunanModif: susunan,
                                    canMove: [],
                                    logMoves: [],
                                    jalanLawan: [],
                                    focus: '',
                                    allPromot: {},
                                    pionSelectPromotion: '',
                                    popupPromosi: false,
                                    runaway: 'b'
                                });
                                setTimeout(() => {
                                    this.props.postMessage(`position fen ${this.props.susunanModif} ${this.props.runaway} - - 0 1`);
                                    this.props.postMessage(`d`);
                                    this.props.postMessage(`go depth 12`);
                                }, 500);
                            }}>
                                <Piece />
                            </div>
                        )
                    })}
                </div>
            </div>
        ) : null;
    }

    render() {
        return (
            <div className="board">
                {this.renderLine()}
                {this.win()}
                {this.lose()}
                {this.popupPromosi()}
            </div>
        );
    }
}

export default dispactConnect((Board), combineAction(Action.HomeAction), ['HomeReducer']);
